<template>
  <v-container>
    <v-text-field
      v-model="sdCardTotalCapacity"
      label="Total capacity"
      :disabled="sdCardAvailable"
    ></v-text-field>
    <v-switch
      v-model="sdCardReadOnly"
      label="SD card read-only"
      :disabled="sdCardAvailable"
    ></v-switch>
    <v-switch
      v-model="sdCardAvailable"
      label="SD card available"
    ></v-switch>
    <v-btn
      @click="readDirTree()"
    >
      Read Dir Tree
    </v-btn>
    <v-treeview
      v-model="fileTree"
      :items="fileItems"
      activatable
      item-key="name"
      open-on-click
      dense
    >
      <template v-slot:prepend="{ item, open }">
        <v-icon v-if="item.children">
          {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
        </v-icon>
        <v-icon v-else>
          {{ 'mdi-file-document-outline' }}
        </v-icon>
      </template>
      <template v-slot:append="{ item }">
        <v-btn
          v-if="!item.children"
          color="green"
          dark
          @click="downloadFile(item.filename, item.name)"
        >
          <v-icon>mdi-cloud-download</v-icon>
        </v-btn>
        <v-btn
          v-if="item.children"
          color="green"
          dark
          @click="showFileUploadDialog(item.dirname)"
        >
          <v-icon>mdi-cloud-upload</v-icon>
        </v-btn>
      </template>
    </v-treeview>
    <v-dialog
      v-model="uploadFileDialogIsVisible"
      max-width="600px"
    >
      <v-card>
        <v-card-title>Upload a file</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="3">File</v-col>
              <v-col cols="9">
                <v-btn
                  @click="$refs.uploadFileInput.click()"
                >
                  Select file
                </v-btn>
                <input
                  @change="onUploadFileInputChanged()"
                  ref="uploadFileInput"
                  type="file"
                  style="display: none"
                >
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="3">File name</v-col>
              <v-col cols="5">
                <v-text-field
                  v-model="uploadFileDirname"
                ></v-text-field>
              </v-col>
              <v-col cols="1" class="align-self-center">
                /
              </v-col>
              <v-col cols="3">
                <v-text-field
                  v-model="uploadFileFilename"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            @click="uploadFileDialogIsVisible = false"
            text
          >
            Abbrechen
          </v-btn>
          <v-btn
            @click="uploadFile()"
            :disabled="!uploadFileIsSelected || !uploadFileFilename"
          >
            Upload
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>

import { startDownload, readFile, } from '@/utils';
import state from '@/state';

export default {
  props: [
    'bridge',
  ],

  data: () => ({
    fileTree: [],
    fileItems: [],
    sdCardTotalCapacity: 10240,
    sdCardAvailable: false,
    sdCardReadOnly: false,
    uploadFileDirname: null,
    uploadFileIsSelected: false,
    uploadFileFilename: null,
    uploadFileDialogIsVisible: false,
  }),

  watch: {
    sdCardAvailable() {
      if (this.sdCardAvailable) {
        this.bridge.setFileTotalCapacity(+this.sdCardTotalCapacity);
      }
      this.bridge.setFileState(this.sdCardAvailable, this.sdCardReadOnly);
    },
  },

  methods: {
    readDirTree() {
      const filenames = this.bridge.readDirTree();
      filenames.sort();
      // console.log(filenames);

      const items = [];
      for (const filename of filenames) {
        const parts = filename.split('/');
        let parentItems = items;
        for (let i = 0; i < parts.length; i++) {
          const part = (i === 0) ? '/' : parts [i];
          const isFile = (i === (parts.length - 1));

          let item = parentItems.find(item => item.name === part);
          if (!item) {
            item = {
              name: part,
            };
            if (isFile) {
              item.filename = filename;
            } else {
              item.dirname = parts.slice(0, i + 1).join('/');
              item.children = [];
            }
            parentItems.push(item);
          }

          parentItems = item.children;
        }
      }

      this.fileItems = items;
    },

    downloadFile(filename, relFilename) {
      const buffer = this.bridge.readFile(filename);

      startDownload(relFilename, 'application/octet-stream', buffer);
    },

    showFileUploadDialog(dirname) {
      this.uploadFileDirname = dirname;
      this.uploadFileFilename = null;
      this.uploadFileDialogIsVisible = true;
    },

    onUploadFileInputChanged() {
      const file = this.$refs.uploadFileInput.files.item(0);
      this.uploadFileIsSelected = !!file;
      if (file) {
        if (!this.uploadFileFilename) {
          this.uploadFileFilename = file.name;
        }
      }
    },

    uploadFile() {
      state.runAsync(async () => {
        const buffer = await readFile(this.$refs.uploadFileInput);

        let filename = this.uploadFileDirname;
        if (!filename.endsWith('/')) {
          filename += '/';
        }
        filename += this.uploadFileFilename;

        this.bridge.writeFile(filename, buffer);

        this.readDirTree();

        this.uploadFileDialogIsVisible = false;
      });
    },
  },
};
</script>

<style>

</style>
